module.exports = __webpack_public_path__ + "static/support_panel-98bf53894ba4fc23174102d2047a8ef2.png";